
import kirbyimage from '../kirbyimage.vue'
export default {
  components: { kirbyimage },
    name:"descCard",
    props: {
        index: Number,
        card: Object
    }
}
